import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-required-message',
  templateUrl: './required-message.component.html',
  styleUrls: ['./required-message.component.scss'],
})
export class RequiredMessageComponent {
  @Input() message: string =
    ' Los campos marcados con asterisco (*) son obligatorios para continuar con el proceso.';
}
